import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getSoilCompositionCatalog = state => state.models[name].data;
export const getCurSoilComposition = state => state.models[name].item;